import styled from 'styled-components';
import { Form } from 'formik';
import { Box, Label, Link, Button } from '@resideo/blueprint-react';
import { PhoneInputField } from '@resideo/blueprint-formik';

export const FormContainer = styled(Form)`
  width: 100%;
  max-width: 500px;
`;

export const TermsContainer = styled(Box)`
  display: flex;
`;

export const StyledCheckboxWrapper = styled(Label)`
  min-width: 32px;
`;

export const NextButton = styled(Button)`
  width: 325px;

  @media (max-width: ${({ theme }) => theme.breakpoints.large}) {
    width: 262px;
  }
`;

export const EmailErrorDiv = styled.div`
  display: flex;
  @media (max-width: ${({ theme }) => theme.breakpoints.large}) {
    display: inline-grid;
  }
`;

export const NavLink = styled(Link)`
  font-size: 14px !important;
  padding-left: 3px;
  text-decoration: none;
  color: ${({ theme }) => theme.colors.primary};
  @media (max-width: ${({ theme }) => theme.breakpoints.large}) {
    padding-left: 0;
  }
`;

export const EmailError = styled.p`
  font-size: 14px;
  margin: 0;
`;

export const RecaptchaErrorMessage = styled.p`
  color: #d22730;
  font-size: 14px;
  margin: 0;
  padding-top: 0.25rem;
`;

export const PhoneInput = styled(PhoneInputField)`
  border-color: #cccccc !important;
`;
